module.exports = __webpack_public_path__ + "img/Funfit_FC_Logo.7b1c9e8a.png";